import UExport from './src/main'

/* istanbul ignore next */
UExport.install = function(Vue) {
  Vue.component(UExport.name, UExport)
}

export default UExport
